// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1nQvy","paramInput":"JobSimulator_paramInput__21V6F","input":"JobSimulator_input__1zbV9"};